/**
 * The pack page's remount key — operator fix, narcis_funnel step 5 follow-up (2026-07-25,
 * DEVIATIONS.md #44). Repro: as an owner on a pack page, start a run, then click a related-strip
 * pack — the URL and document change to the new pack, but the stage kept rendering the PREVIOUS
 * pack's run.
 *
 * Root cause: React Router does not remount `_layout.$packSlug.tsx`'s component on a
 * route-param-only navigation (same route id, new `packSlug` param), so `PackLandingTemplate`'s
 * local state (the owner's run, the open intake, the wall-write guard) survived a related-pack
 * click intact.
 *
 * Fix: `key={packInstanceKey(pack.slug)}` on `<PackLandingTemplate>` (`_layout.$packSlug.tsx`)
 * forces a genuine unmount/mount on slug change, the same as a hard navigation.
 *
 * Pure so "what identifies a distinct pack instance" is unit-testable without mounting React.
 */
export function packInstanceKey(packSlug: string): string {
    return `pack-instance:${packSlug}`
}
